// TODO: Start refactoring all API calls to be called from here.

import {
  GET_DRAFT_INDEX_ENDPOINT, GET_SEARCH_RESULTS, PUT_VISUAL_STATUS_ENDPOINT,
  GET_USER_BY_ID, GET_USER_ACTIVITIES_BY_ID, PUT_USER_PROFILE_ENDPOINT, POST_FOLLOW_USER_ENDPOINT,
} from '../constants';
import { getRequest, putRequest, postRequest } from '../utils/apiRequestUtils';
import { searchResultGetParser } from './dataParsers';
import { apiDeserializer, apiSerializer } from '../utils/jsonApiSerializer';
import { convertToFormDataObject, flattenJSONApiParams } from '../utils/dataTransform';

async function searchResults(params) {
  const searchResults = await getRequest(GET_SEARCH_RESULTS, {}, params);
  const {
    data: {
      search_results: {
        user_results: {
          data: userList,
        },
      },
    },
  } = searchResults.data;

  return searchResultGetParser(userList);
}

export function searchUsers(query) { return searchResults({ query_type: 'users', query }); }

export function getSketchpadStorageParam(data) {
  return apiSerializer('sketchpad_storages', data, { attributes: ['parentId', 'rootId'] });
}

export async function getDraftIndex(headers, { parentId, rootId }) {
  let params = getSketchpadStorageParam({ parentId, rootId });
  params = flattenJSONApiParams(params);

  const response = await getRequest(GET_DRAFT_INDEX_ENDPOINT, headers, params);
  response.data = await apiDeserializer(response.data);

  return response;
}

export async function getUserInfo(userId, headers) {
  const userInfo = await getRequest(GET_USER_BY_ID(userId), headers);
  userInfo.data = await apiDeserializer(userInfo.data);
  return userInfo;
}

export function putRequestSchemaforEditVcDetails({ level: authLvl, title }) {
  return apiSerializer('visual_statuses', { authLvl, title }, { attributes: ['authLvl', 'title'] });
}

export async function putRequestForEditVcDetails(headers, data) {
  const editVcResponse = await putRequest(PUT_VISUAL_STATUS_ENDPOINT(data.id),
    putRequestSchemaforEditVcDetails(data), headers);
  editVcResponse.data = await apiDeserializer(editVcResponse.data);
  return editVcResponse;
}

export async function userActivities(userId, params) {
  const userActivities = await getRequest(GET_USER_ACTIVITIES_BY_ID(userId), null, params);
  userActivities.data = await apiDeserializer(userActivities.data);
  return userActivities;
}

export function updateProfilePayload(payload) {
  return apiSerializer('users', payload, { attributes: ['email', 'name', 'photo', 'country'] });
}

export async function updateProfile(userId, payload, headers) {
  const formDataPayload = convertToFormDataObject(updateProfilePayload(payload));
  const updateProfile = await putRequest(PUT_USER_PROFILE_ENDPOINT(userId), formDataPayload, headers);
  updateProfile.data = await apiDeserializer(updateProfile.data);
  return updateProfile.data;
}

export function postRequestSchemaforFollowUser(followedId) {
  return apiSerializer('follows', { followedId }, { attributes: ['followedId'] });
}

export async function followUserAPI(userId, headers) {
  const followUser = await postRequest(POST_FOLLOW_USER_ENDPOINT,
    postRequestSchemaforFollowUser(userId), headers);
  followUser.data = await apiDeserializer(followUser.data);
  return followUser;
}



// WEBPACK FOOTER //
// ./src/api/index.js